export const columnMapping = {
  canceled_interview: 'canceled',
  uploaded_application: 'applicationsUploaded',
  scheduled_interview: 'scheduled',
  positions: 'positionsFilled',
};
